import React, { Component, useDebugValue } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { Button, ScrollView } from "devextreme-react";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarCpbsDs } from "../../DataSources";
import openReport from "../../openReport";
import apiAxios from "../../api-axios";
import UserInfo from "../../UserInfo";
import Memoria from "../../Memoria";
import ShowError from "../../AppServices";
import notify from "devextreme/ui/notify";
import showReport from "../../showReport";

let filtroTemplate = {
  nome: null,
  inscricao: null,
  fantasia: null,
  cpfCnpj: null,
  tipoIss: -1,
  simplesNacional: 0,
  tipoEscrituracao: -1,
};

export default class CpbsBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this._usersGridInstance = React.createRef();
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: { ...filtroTemplate },
      showUserPopup: false,
      cpbsUsers: [],
      showPassword: [],
    };
    this.cpbsDs = criarCpbsDs();
    this.filtrar = this.filtrar.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.imprimirCartaoIss = this.imprimirCartaoIss.bind(this);
    this.imprimirFichaCpbs = this.imprimirFichaCpbs.bind(this);
    this.getCpbsUsers = this.getCpbsUsers.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.cellRender = this.cellRender.bind(this);
    this.showCellPassword = this.showCellPassword.bind(this);

    this.tipoIssOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: "TODOS" },
        { id: 0, descricao: "NÃO CONTRIBUINTE" },
        { id: 1, descricao: "NORMAL" },
        { id: 2, descricao: "AUTÔNOMO" },
        { id: 3, descricao: "SOC. PROFISSIONAIS" },
        { id: 4, descricao: "ESTIMATIVA" },
        { id: 7, descricao: "MEI" },
      ],
      displayExpr: "descricao",
      valueExpr: "id",
    };

    this.simplessOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "TODOS" },
        { id: 1, descricao: "SIM" },
        { id: 2, descricao: "NÃO" },
      ],
      displayExpr: "descricao",
      valueExpr: "id",
    };

    this.escrituracaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: "TODOS" },
        { id: 0, descricao: "PRESTADOR" },
        { id: 1, descricao: "SUBSTITUTO" },
        { id: 2, descricao: "MISTO" },
        { id: 3, descricao: "SEM ESCRITURAÇÃO" },
      ],
      displayExpr: "descricao",
      valueExpr: "id",
    };
  }

  imprimirCartaoIss(e) {
    showReport(`report/cartao_iss/${e.row.data.id}/${UserInfo.getPrefeitura()}`);
  }

  imprimirFichaCpbs(e) {
    showReport(`report/ficha_cpbs/${e.row.data.id}`);
  }

  async getCpbsUsers(cpbs) {
    try {
      const response = await apiAxios.get(
        `cpbs/prefeitura/${cpbs.prefeituraId}/${cpbs.id}/usuarios`
      );
      if (response.status === 200) {
        this.setState({
          showUserPopup: true,
          cpbsUsers: response.data
        });
      }
    } catch (error) {
      ShowError(error);
    }
  }

  clearFilter() {
    this.setState({
      filtro: { ...filtroTemplate },
    });
    this.filtrar();
  }

  componentDidMount() {
    Memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("cpbs/editar/" + e.data.id);
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.sequencial && filtro.sequencial !== "") {
      filtroCorrente.push(["inscricao", "=", filtro.sequencial]);
    }
    if (filtro.nome && filtro.nome !== "") {
      filtroCorrente.push([
        "contribuinte.nome",
        "contains",
        filtro.nome.trim(),
      ]);
    }
    if (filtro.fantasia && filtro.fantasia !== "") {
      filtroCorrente.push(["fantasia", "contains", filtro.fantasia.trim()]);
    }
    if (filtro.cpfCnpj && filtro.cpfCnpj !== "") {
      let cpfCnpj = filtro.cpfCnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      filtroCorrente.push(["contribuinte.cpfCnpj", "contains", cpfCnpj]);
    }
    if (filtro.inscricaoContribuinte && filtro.inscricaoContribuinte !== "") {
      filtroCorrente.push([
        "contribuinte.sequencial",
        "=",
        filtro.inscricaoContribuinte,
      ]);
    }
    if (filtro.tipoIss && filtro.tipoIss !== -1) {
      filtroCorrente.push(["tipoIss", "=", filtro.tipoIss]);
    }
    if (filtro.simplesNacional && filtro.simplesNacional !== -1) {
      filtroCorrente.push(["optanteSimples", "=", filtro.simplesNacional == 1]);
    }

    if (filtro.tipoEscrituracao && filtro.tipoEscrituracao !== -1) {
      filtroCorrente.push(["tipoEscrituracao", "=", filtro.tipoEscrituracao]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  render() {
    return (
      <React.Fragment>
        <div
          className={"content-block dx-card responsive-paddings"}
          style={{ height: "100%" }}
        >
          <form onSubmit={this.filtrar}>
            <Form id="frmPesquisa" formData={this.state.filtro} colCount={4}>
              <SimpleItem
                dataField="sequencial"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ step: 0, value: null }}
              >
                <Label text="Inscrição" />
              </SimpleItem>
              <SimpleItem dataField="nome" colSpan={3}>
                <Label text="Nome" />
              </SimpleItem>
              <SimpleItem dataField="cpfCnpj" colSpan={1}>
                <Label text="CPF/CNPJ" />
              </SimpleItem>

              <SimpleItem dataField="fantasia" colSpan={3}>
                <Label text="Fatansia/Apelido" />
              </SimpleItem>
              <SimpleItem
                dataField="tipoIss"
                colSpan={1}
                editorType={"dxSelectBox"}
                editorOptions={this.tipoIssOptions}
              >
                <Label text="Tipo ISS" />
              </SimpleItem>
              <SimpleItem
                dataField="simplesNacional"
                colSpan={1}
                editorType={"dxSelectBox"}
                editorOptions={this.simplessOptions}
              >
                <Label text="Optante Simples" />
              </SimpleItem>
              <SimpleItem
                dataField="tipoEscrituracao"
                colSpan={1}
                editorType={"dxSelectBox"}
                editorOptions={this.escrituracaoOptions}
              >
                <Label text="Tipo Escrituração" />
              </SimpleItem>
              <SimpleItem
                dataField="inscricaoContribuinte"
                editorType={"dxNumberBox"}
                editorOptions={{ step: 0, value: null }}
                colSpan={1}
              >
                <Label text="IMC" />
              </SimpleItem>
            </Form>
            <br />
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Limpar Filtro"
                  onClick={this.clearFilter}
                />
              </div>
            </div>
          </form>
          <br /> <br />
          <PaginaToolbar
            titulo="Lista de Econômicos"
            novoCb={this.novoCpbs.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.cpbsDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              onEditingStart={this.onAtualizandoRow}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              keyExpr={"id"}
            >
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={!this.usadoComoPesquisa}
                useIcons={true}
              />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.props.onSelecionado,
                  },
                  {
                    hint: "Cartão Iss",
                    icon: "card",
                    visible: !this.usadoComoPesquisa,
                    onClick: (e) => this.imprimirCartaoIss(e),
                  },
                  {
                    hint: "Ficha CPBS",
                    icon: "bulletlist",
                    visible: !this.usadoComoPesquisa,
                    onClick: (e) => this.imprimirFichaCpbs(e),
                  },
                  {
                    hint: "Usuários do CPBS",
                    icon: "group",
                    visible: !this.usadoComoPesquisa,
                    onClick: (e) => this.getCpbsUsers(e.row.data),
                  },
                ]}
              />
              <Column dataField={"inscricao"} caption={"#"} width={100} />
              <Column dataField={"categoria.descricao"} caption={"Categoria"} />

              <Column
                dataField={"contribuinte.cpfCnpj"}
                caption={"CPF/CNPJ"}
                width={130}
              />
              <Column dataField={"contribuinte.nome"} caption={"Nome"} />
              <Column dataField={"fantasia"} caption={"Fantasia"} />
              <Column dataField={"tipoIssStr"} caption={"Regime ISS"} />
              <Column
                dataField={"tipoSimplesNacionalStr"}
                caption={"Simples Nacional"}
              />
              <Column
                dataField={"tipoEscrituracaoStr"}
                caption={"Tipo Escrituração"}
              />
              <Column
                dataField={"dataDeCadastro"}
                dataType={"date"}
                caption={"Dt. Cadastro"}
              />
              <Column dataField={"dispensaIssStr"} caption={"Dispensa ISS"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
          <Popup
            visible={this.state.showUserPopup}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={false}
            showTitle={true}
            title={"Usuários NFS-e"}
            onHiding={() => this.setState({ showUserPopup: false })}
            width="1000px"
            height="600px"
          >
            <ScrollView>
              <div style={{ marginBottom: 15 }}>
                <Form id="frmDadosUsuarioCpbs" formData={this.state.cpbsUsers} colCount={3}>
                  <SimpleItem
                    dataField="optanteSimples"
                    colSpan={1}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Optante Simples" />
                  </SimpleItem>
                  <SimpleItem
                    dataField="tipoIss"
                    colSpan={1}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Tipo ISS" />
                  </SimpleItem>
                  <SimpleItem
                    dataField="autorizacaoNfse"
                    colSpan={1}
                    editorOptions={{ readOnly: true }}
                  >
                    <Label text="Autorização NFS-e" />
                  </SimpleItem>
                </Form>
              </div>
              <DataGrid
                ref={(grid) => (this._usersGridInstance = grid)}
                dataSource={this.state.cpbsUsers.usuarios}
                showBorders={true}
                rowAlternationEnabled={true}
                remoteOperations={true}
                columnAutoWidth={true}
                keyExpr={"cpfCnpj"}
              >
                <Column
                  type="buttons"
                  fixed={true}
                  fixedPosition={"left"}
                  buttons={[
                    {
                      hint: "Copiar Acesso",
                      icon: "export",
                      onClick: (e) => {
                        navigator.clipboard.writeText(e.row.data.textoAcesso);
                        notify(`Acesso de '${e.row.data.nome}' copiado.`, "success");
                      },
                    },
                    {
                      hint: "Senha",
                      icon: "key",
                      onClick: this.showCellPassword,
                    },
                  ]}
                />
                <Column
                  dataField={"cpfCnpj"}
                  caption={"Documento"}
                  width={150}
                />
                <Column dataField={"login"} caption={"Login"} width={150} />
                <Column dataField={"nome"} caption={"Nome"} />
                <Column
                  dataField={"senha"}
                  caption={"Senha"}
                  cellRender={this.cellRender}
                />
                <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                <Pager
                  showInfo={true}
                  showNavigationButtons={true}
                  showPageSizeSelector={true}
                  allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                />
              </DataGrid>
              <div style={{ color: "red", marginTop: 10, marginBottom: 10 }}>Observação: usuários com 'Autorizção NFS-e' definida como NÃO, não devem ter acesso ao sistema de notas fiscais eletrônicas.</div>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                width: 150,
                onClick: () => this.setState({ showUserPopup: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  cellRender(event) {
    if (this.state.showPassword.includes(event.key)) {
      return event.value;
    }
    return "********";
  }

  showCellPassword(event) {
    const passwords = this.state.showPassword;
    const rowKey = event.row.key;
    if (this.state.showPassword.includes(rowKey)) {
      const passwordIndex = this.state.showPassword.indexOf(rowKey);
      passwords.splice(passwordIndex, 1);
    } else {
      passwords.push(rowKey);
    }
    this.setState({ showPassword: passwords });
  }

  novoCpbs() {
    this.props.history.push("cpbs/novo");
  }

  limparFiltro() {
    // por implementar
  }
}
